import React, { Component, useMemo } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import styled from 'styled-components';
import MainContent from './MainContent';
import NecHeaderLogo from '../assets/Logo_page-header.png';

const MainPageCompenent = (props) => {
    const Container = styled.div`
        width: 100%;
        min-height: 100vh;
        background: #0072bc;
    `;
    const MainHeaderContainer = styled.div`
        background-image: repeating-linear-gradient(45deg, #0072bc 0%, rgba(3, 78, 162, 0.5) 1%, #0072bc 2%);
        box-shadow: inset 0px -40px 50px 40px rgba(0, 114, 178, 0.6);
    `;

    const Footer = styled.div`
        background-image: repeating-linear-gradient(45deg, #0072bc 0%, rgba(3, 78, 162, 0.5) 1%, #0072bc 2%);
        box-shadow: inset 0px -40px 50px 40px rgba(0, 114, 178, 0.6);
        height: 30px;
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
    `;

    const HeaderFirstLine = styled.div`
        height: 30px;
        display: flex;
    `;

    const HeaderLogoBorder = styled.div`
        background-image: linear-gradient(90deg, #ffffff 0%, #414042 20%, #ffffff 50%, #414042 80%, #ffffff 100%);
        height: 1px;
        display: flex;
    `;

    const HeaderLogoMainImage = styled.div`
        background-image: linear-gradient(90deg, #012d50 0%, #0072bc 20%, #0072bc 80%, #012d50 100%);
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.5);
    `;

    const HeaderEndLine = styled.div`
        height: 30px;
        display: flex;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        font-size: 16px;
        justify-content: center;
    `;
    const MainComponent = useMemo(() => props.children);
    return (
        <>
            {/* <Sidebar /> */}
            <Container>
                <MainHeaderContainer>
                    <HeaderFirstLine />
                    <HeaderLogoBorder />
                    <HeaderLogoMainImage>
                        <img src={NecHeaderLogo} style={{ height: '85%' }} />
                    </HeaderLogoMainImage>
                    <HeaderLogoBorder />
                    <HeaderEndLine><span style={{fontSize:'1.2rem'}}>PROFETIONAL TOOLS</span></HeaderEndLine>
                </MainHeaderContainer>
                {MainComponent}
                <Footer />
            </Container>
        </>
    );
}

export default MainPageCompenent;